import { memo } from "react";
import { IconButton, Tooltip } from "@mui/material";
import GlobalIcon from "../GlobalIcon/GlobalIcon";
import { formatRefreshTimestamp } from "../../utils/bookRefreshTime";
import styles from "./BookRefreshBar.module.css";

function BookRefreshBar({ lastRefreshAt, onReload, isLoading, disabled }) {
  const stamp =
    lastRefreshAt != null ? formatRefreshTimestamp(lastRefreshAt) : "";

  return (
    <div className={styles.wrap}>
      {isLoading ? (
        <span className={styles.meta}>Loading…</span>
      ) : stamp ? (
        <span className={styles.meta}>
          Last refreshed: <span className={styles.metaTime}>{stamp}</span>
        </span>
      ) : (
        <span className={styles.meta}>—</span>
      )}
      <Tooltip title="Refresh">
        <span className={styles.iconBtnWrap}>
          <IconButton
            type="button"
            size="small"
            className={styles.reloadIconBtn}
            onClick={onReload}
            disabled={disabled || isLoading}
            aria-label="Refresh"
          >
            <GlobalIcon iconName="RefreshIcon" width={14} height={14} aria-hidden />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  );
}

export default memo(BookRefreshBar);
